
//import leeLoadimg from '@/LeeLoadimg'
export default {
    name: 'LeeButton',
    components: {
        //leeLoadimg
    },
    data() {
        return {
            thetype: 'default',
            theactive: 'default',
            number: this.num
        };
    },
    mounted() {
        let st = setInterval(() => {
            this.number--
            if (this.number <= 0) {
                clearInterval(st)
            }
        }, 1000)
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {
                let types = ['primary', 'success', 'info', 'warning', 'danger', 'disabled', 'leecolor', 'loadding', 'countDown']
                let fi = types.filter(function (el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thetype = "default"
                } else {
                    this.thetype = value
                }
            }
        },
        active: {
            immediate: true,
            handler(value) {
                let types = ['ball', 'wave', 'flash']
                let fi = types.filter(function (el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.theactive = "default"
                } else {
                    this.theactive = value
                }
            }
        }
    },
    props: {
        type: {
            type: String,
            default: 'default' //默认default
        },
        active: {
            type: String,
            default: 'default' //默认default
        },
        num: {
            type: Number,
            default: 10 //默认default
        }
    },
    computed: {
        buttonListeners1() {
            var vm = this;
            return Object.assign({}, this.$listeners, {
                click: function (event) {
                    vm.$emit('click', event);
                }
            })
        },
        buttonListeners2() {
            var vm = this;
            return Object.assign({}, this.$listeners, {
                click: function (event) {
                    vm.$emit('click', event);
                },
                mousemove: function (event) {
                    // let x = event.pageX - event.target.offsetLeft;
                    // let y = event.pageY - event.target.offsetTop;
                    let x = event.offsetX;
                    let y = event.offsetY;
                    event.target.parentNode.style.setProperty('--x', x + 'px')
                    event.target.parentNode.style.setProperty('--y', y + 'px')
                },
            })
        }
    }
};
